import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "signup-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "form-section" }
const _hoisted_4 = { class: "compact-field" }
const _hoisted_5 = { class: "address-input-group" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "id-check-message error"
}
const _hoisted_10 = { class: "compact-field" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "compact-field" }
const _hoisted_13 = { class: "input-with-suffix" }
const _hoisted_14 = ["type", "disabled"]
const _hoisted_15 = { class: "compact-field" }
const _hoisted_16 = { class: "input-with-suffix" }
const _hoisted_17 = ["type", "disabled"]
const _hoisted_18 = {
  key: 0,
  class: "id-check-message error"
}
const _hoisted_19 = {
  key: 1,
  class: "id-check-message success"
}
const _hoisted_20 = { class: "terms-checkbox-wrapper" }
const _hoisted_21 = { class: "terms-checkbox-label" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';

interface SignupData {
  m_id: string;
  m_pw: string;
  confirmPw: string;
  m_longterm_code: string;
  m_role: string;
  m_status: string;
  m_isuse: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PgmSignup',
  setup(__props) {

const router = useRouter();

// 이미지 경로 설정
const logoImage = ref(new URL('../../../assets/images/hypehive-logo.png', import.meta.url).href);

// 반응형 데이터
const signupData = ref<SignupData>({
  m_id: '',
  m_pw: '',
  confirmPw: '',
  m_longterm_code: '',
  m_role: 'user',
  m_status: 'req',
  m_isuse: 'N',
});

const agreeTerms = ref(false);
const loading = ref(false);
const isSubmitting = ref(false);
const signupForm = ref();
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const snackbar = ref({ show: false, message: '', color: 'info' });
const showTermsModal = ref(false);
const showPrivacyModal = ref(false);
const checkingId = ref(false);
const idCheckMessage = ref('');
const idCheckStatus = ref('');
const isIdAvailable = ref(false);

// 폼 유효성 검사
const isFormValid = computed(() => {
  const d = signupData.value;
  // 아이디 중복 확인, 비밀번호 일치, 약관 동의만 확인
  return isIdAvailable.value && 
         d.m_pw && 
         d.confirmPw && 
         d.m_pw === d.confirmPw && 
         agreeTerms.value;
});

// 회원가입 처리
const handleSignup = async () => {
  if (!isFormValid.value) {
    if (!isIdAvailable.value) {
      snackbar.value.message = '아이디 중복확인이 필요합니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (!signupData.value.m_pw || !signupData.value.confirmPw) {
      snackbar.value.message = '비밀번호를 입력해주세요.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (signupData.value.m_pw !== signupData.value.confirmPw) {
      snackbar.value.message = '비밀번호가 일치하지 않습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    if (!agreeTerms.value) {
      snackbar.value.message = '이용약관에 동의해주세요.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
      return;
    }
    return;
  }
  
  // 이미 처리 중이면 중복 실행 방지
  if (isSubmitting.value) return;
  
  isSubmitting.value = true;
  loading.value = true;
  
  try {
    // 회원가입 데이터 준비 (confirmPw 제외)
    const { confirmPw, ...signupFormData } = signupData.value;
    
    const response = await fetch('/api/auth/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ form: signupFormData }),
    });
    
    const result = await response.json();
    
    if (result.success) {
      snackbar.value.message = '회원가입이 완료되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
      setTimeout(() => router.push('/pgm/login'), 800);
    } else {
      console.error('회원가입 실패:', result.message);
      snackbar.value.message = result.message || '회원가입에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('회원가입 오류:', error);
    snackbar.value.message = '회원가입 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    loading.value = false;
    isSubmitting.value = false;
  }
};

// 로그인 페이지로 이동
const goToLogin = () => {
  router.push('/pgm/login');
};

// 아이디 입력 처리
const onIdInput = () => {
  // 아이디가 변경되면 중복확인 상태 초기화
  idCheckMessage.value = '';
  idCheckStatus.value = '';
  isIdAvailable.value = false;
};

// 아이디 중복확인
const checkIdDuplicate = async () => {
  if (!signupData.value.m_id || signupData.value.m_id.length < 6) {
    idCheckMessage.value = '6자 이상 입력해주세요.';
    idCheckStatus.value = 'error';
    return;
  }

  checkingId.value = true;
  idCheckMessage.value = '';
  idCheckStatus.value = '';

  try {
    const response = await fetch(`/api/auth/memberIdCheck/${signupData.value.m_id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();

    if (result.success) {
      // 중복됨
      idCheckMessage.value = '이미 사용 중인 아이디입니다.';
      idCheckStatus.value = 'error';
      isIdAvailable.value = false;
    } else {
      // 사용 가능
      idCheckMessage.value = '사용 가능한 아이디입니다.';
      idCheckStatus.value = 'success';
      isIdAvailable.value = true;
    }
  } catch (error) {
    console.error('아이디 중복확인 오류:', error);
    idCheckMessage.value = '중복확인 중 오류가 발생했습니다.';
    idCheckStatus.value = 'error';
    isIdAvailable.value = false;
  } finally {
    checkingId.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "signup-card",
      elevation: "8"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "text-center pl-4 pr-4 pt-3 pb-2 signup-title" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: logoImage.value,
              height: "36",
              width: "auto",
              class: "mb-1 logo-filter"
            }, null, 8, _hoisted_2),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "signup-title-text" }, "회원가입", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "signup-subtitle" }, "재가장기요양센터 관리 시스템", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              ref_key: "signupForm",
              ref: signupForm,
              onSubmit: _withModifiers(handleSignup, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "section-title" }, "기본 정보", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "compact-label" }, "아이디 *", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((signupData.value.m_id) = $event)),
                        type: "text",
                        class: "compact-input",
                        placeholder: "아이디를 입력하세요",
                        disabled: loading.value || checkingId.value,
                        maxlength: "20",
                        autocomplete: "username",
                        onInput: onIdInput
                      }, null, 40, _hoisted_6), [
                        [_vModelText, signupData.value.m_id]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "address-search-btn id-check-btn",
                        disabled: !signupData.value.m_id || signupData.value.m_id.length < 6 || loading.value || checkingId.value,
                        onClick: checkIdDuplicate
                      }, [
                        (checkingId.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "16",
                              width: "2",
                              color: "white",
                              class: "mr-1"
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, "중복확인"))
                      ], 8, _hoisted_7)
                    ]),
                    (idCheckMessage.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['id-check-message', idCheckStatus.value])
                        }, _toDisplayString(idCheckMessage.value), 3))
                      : _createCommentVNode("", true),
                    (!idCheckMessage.value && signupData.value.m_id && signupData.value.m_id.length < 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 6자 이상 입력해주세요. "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "compact-label" }, "장기요양기관기호 *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((signupData.value.m_longterm_code) = $event)),
                      type: "text",
                      class: "compact-input",
                      placeholder: "장기요양기관기호를 입력하세요",
                      disabled: loading.value,
                      autocomplete: "off",
                      maxlength: "15"
                    }, null, 8, _hoisted_11), [
                      [_vModelText, signupData.value.m_longterm_code]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "compact-label" }, "비밀번호 *", -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((signupData.value.m_pw) = $event)),
                        type: showPassword.value ? 'text' : 'password',
                        class: "compact-input",
                        placeholder: "비밀번호를 입력하세요",
                        disabled: loading.value,
                        autocomplete: "new-password",
                        maxlength: "50"
                      }, null, 8, _hoisted_14), [
                        [_vModelDynamic, signupData.value.m_pw]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "password-toggle-btn",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value))
                      }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "compact-label" }, "비밀번호 확인 *", -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((signupData.value.confirmPw) = $event)),
                        type: showConfirmPassword.value ? 'text' : 'password',
                        class: "compact-input",
                        placeholder: "비밀번호를 다시 입력하세요",
                        disabled: loading.value,
                        autocomplete: "new-password",
                        maxlength: "50"
                      }, null, 8, _hoisted_17), [
                        [_vModelDynamic, signupData.value.confirmPw]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "password-toggle-btn",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value))
                      }, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showConfirmPassword.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (signupData.value.confirmPw && signupData.value.m_pw && signupData.value.confirmPw !== signupData.value.m_pw)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 비밀번호가 일치하지 않습니다. "))
                      : _createCommentVNode("", true),
                    (signupData.value.confirmPw && signupData.value.m_pw && signupData.value.confirmPw === signupData.value.m_pw)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 비밀번호가 일치합니다. "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_checkbox, {
                    modelValue: agreeTerms.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((agreeTerms).value = $event)),
                    color: "primary",
                    disabled: loading.value,
                    density: "compact",
                    class: "terms-checkbox"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", _hoisted_21, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showTermsModal.value = true), ["prevent"])),
                          class: "terms-link"
                        }, "이용약관"),
                        _cache[21] || (_cache[21] = _createTextVNode(" 및 ", -1)),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (showPrivacyModal.value = true), ["prevent"])),
                          class: "terms-link"
                        }, "개인정보처리방침"),
                        _cache[22] || (_cache[22] = _createTextVNode("에 동의합니다. ", -1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, { class: "pl-4 pr-4 pt-2 pb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: handleSignup,
              color: "primary",
              variant: "flat",
              block: "",
              size: "default",
              loading: loading.value,
              disabled: !isFormValid.value || isSubmitting.value,
              rounded: "lg",
              class: "signup-submit-btn"
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode(" 신청하기 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_card_actions, { class: "pl-4 pr-4 pt-2 pb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "text",
              block: "",
              size: "default",
              disabled: loading.value,
              "prepend-icon": "mdi-login",
              onClick: goToLogin,
              class: "login-back-btn"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode(" 로그인으로 돌아가기 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showTermsModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showTermsModal).value = $event)),
      "max-width": "800",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("이용약관", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"height":"500px"} }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createElementVNode("div", { class: "terms-content" }, [
                  _createElementVNode("h3", null, "제1조 (목적)"),
                  _createElementVNode("p", null, "이 약관은 재가장기요양센터 관리 시스템(이하 \"서비스\")을 제공하는 하이파이브 주식회사(이하 \"회사\")와 이를 이용하는 회원(이하 \"이용자\") 간의 서비스 이용에 관한 제반 사항과 기타 필요한 사항을 구체적으로 규정함을 목적으로 합니다."),
                  _createElementVNode("h3", null, "제2조 (정의)"),
                  _createElementVNode("p", null, "1. \"서비스\"라 함은 재가장기요양센터의 운영 관리를 위한 웹 기반 시스템을 의미합니다."),
                  _createElementVNode("p", null, "2. \"이용자\"라 함은 이 약관에 따라 회사가 제공하는 서비스를 받는 회원을 말합니다."),
                  _createElementVNode("p", null, "3. \"회원\"이라 함은 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다."),
                  _createElementVNode("h3", null, "제3조 (약관의 효력 및 변경)"),
                  _createElementVNode("p", null, "1. 이 약관은 서비스를 신청하여 회사의 승낙을 받은 때부터 효력이 발생합니다."),
                  _createElementVNode("p", null, "2. 회사는 약관을 변경하는 경우 변경사유 및 적용일자를 명시하여 현행약관과 함께 서비스 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다."),
                  _createElementVNode("p", null, "3. 회원이 변경된 약관에 동의하지 않는 경우, 회원은 서비스 이용계약을 해지할 수 있습니다."),
                  _createElementVNode("h3", null, "제4조 (서비스의 제공 및 변경)"),
                  _createElementVNode("p", null, "1. 회사는 다음과 같은 업무를 수행합니다:"),
                  _createElementVNode("p", null, "- 재가장기요양센터 운영 관리 시스템 제공"),
                  _createElementVNode("p", null, "- 이용자 정보 관리 및 데이터 보안"),
                  _createElementVNode("p", null, "- 기타 서비스 관련 필수 업무"),
                  _createElementVNode("p", null, "2. 회사는 서비스의 품질 향상을 위해 서비스를 개선할 수 있으며, 중대한 변경사항이 있을 경우 사전에 공지합니다."),
                  _createElementVNode("p", null, "3. 서비스 변경으로 인해 회원에게 불이익이 발생하는 경우, 회사는 합리적인 대안을 제시하거나 보상방안을 마련합니다."),
                  _createElementVNode("h3", null, "제5조 (서비스 이용시간)"),
                  _createElementVNode("p", null, "1. 서비스 이용은 회사의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간 운영을 원칙으로 합니다."),
                  _createElementVNode("p", null, "2. 회사는 시스템 점검, 보수, 교체, 고장, 통신두절 등의 사유로 서비스 제공을 일시 중단할 수 있으며, 예정된 작업의 경우 사전에 공지합니다."),
                  _createElementVNode("p", null, "3. 긴급한 시스템 장애 등 불가피한 사유로 사전 공지가 불가능한 경우, 사후에 즉시 공지하고 조치사항을 안내합니다."),
                  _createElementVNode("h3", null, "제6조 (회원가입)"),
                  _createElementVNode("p", null, "1. 이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다."),
                  _createElementVNode("p", null, "2. 회사는 다음 각 호에 해당하지 않는 한 회원가입 신청을 승낙합니다:"),
                  _createElementVNode("p", null, "- 가입신청자가 이전에 회원자격을 상실한 적이 있는 경우 (단, 회사의 회원재가입 승낙을 얻은 경우는 예외)"),
                  _createElementVNode("p", null, "- 등록 내용에 허위, 기재누락, 오기가 있는 경우"),
                  _createElementVNode("p", null, "- 기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우"),
                  _createElementVNode("p", null, "3. 회원가입계약의 성립시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다."),
                  _createElementVNode("h3", null, "제7조 (회원 탈퇴 및 자격 상실)"),
                  _createElementVNode("p", null, "1. 회원은 언제든지 서비스 내 회원탈퇴 메뉴를 통해 이용계약 해지를 요청할 수 있으며, 회사는 관련 법령에 따라 이를 즉시 처리합니다."),
                  _createElementVNode("p", null, "2. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 사전 통지 후 회원자격을 제한, 정지 또는 상실시킬 수 있습니다:"),
                  _createElementVNode("p", null, "- 가입 신청 시 허위 내용을 등록한 경우"),
                  _createElementVNode("p", null, "- 다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 경우"),
                  _createElementVNode("p", null, "- 서비스를 이용하여 법령과 이 약관이 금지하는 행위를 하는 경우"),
                  _createElementVNode("p", null, "3. 회사가 회원자격을 제한·정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실시킬 수 있습니다."),
                  _createElementVNode("p", null, "4. 회원자격 상실 시 회원에게 부가된 혜택은 모두 소멸되며, 이에 대해 회사는 별도로 보상하지 않습니다."),
                  _createElementVNode("h3", null, "제8조 (개인정보보호)"),
                  _createElementVNode("p", null, "회사는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관해서는 관련법령 및 회사가 정하는 개인정보처리방침에 정한 바에 의합니다."),
                  _createElementVNode("h3", null, "제9조 (회사의 의무)"),
                  _createElementVNode("p", null, "1. 회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 지속적이고 안정적으로 서비스를 제공하기 위해 최선을 다합니다."),
                  _createElementVNode("p", null, "2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보보호를 위한 보안시스템을 구축하고 개인정보처리방침을 공시하고 준수합니다."),
                  _createElementVNode("p", null, "3. 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 즉시 처리하여야 합니다."),
                  _createElementVNode("p", null, "4. 회사는 서비스 이용과 관련하여 회원에게 발생한 손해가 회사의 고의 또는 중과실에 의한 경우 관련 법령에 따라 배상합니다."),
                  _createElementVNode("h3", null, "제10조 (회원의 의무)"),
                  _createElementVNode("p", null, "1. 이용자는 다음 행위를 하여서는 안 됩니다."),
                  _createElementVNode("p", null, "- 신청 또는 변경시 허위 내용의 등록"),
                  _createElementVNode("p", null, "- 타인의 정보 도용"),
                  _createElementVNode("p", null, "- 회사가 게시한 정보의 변경"),
                  _createElementVNode("p", null, "- 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시"),
                  _createElementVNode("p", null, "- 회사 기타 제3자의 저작권 등 지적재산권에 대한 침해"),
                  _createElementVNode("p", null, "- 회사 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위"),
                  _createElementVNode("p", null, "- 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 회사에 공개 또는 게시하는 행위"),
                  _createElementVNode("h3", null, "제11조 (저작권의 귀속 및 이용제한)"),
                  _createElementVNode("p", null, "1. 회사가 작성한 저작물에 대한 저작권 기타 지적재산권은 회사에 귀속합니다."),
                  _createElementVNode("p", null, "2. 회원이 서비스 내에 게시한 게시물에 대한 저작권은 해당 회원에게 귀속됩니다."),
                  _createElementVNode("p", null, "3. 회원은 회사가 제공하는 서비스를 이용하여 얻은 정보 중 지적재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다."),
                  _createElementVNode("p", null, "4. 회사는 회원이 게시하거나 등록하는 서비스 내의 내용물이 다음 각 호에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있습니다:"),
                  _createElementVNode("p", null, "- 다른 회원 또는 제3자에게 심한 모독을 주거나 명예를 손상시키는 내용인 경우"),
                  _createElementVNode("p", null, "- 공공질서 및 미풍양속에 위반되는 내용을 포함하는 경우"),
                  _createElementVNode("p", null, "- 범죄적 행위에 결부된다고 인정되는 내용일 경우"),
                  _createElementVNode("p", null, "- 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우"),
                  _createElementVNode("h3", null, "제12조 (손해배상 및 면책조항)"),
                  _createElementVNode("p", null, "1. 회사는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 회사가 고의 또는 중과실로 인한 손해발생을 제외하고는 이에 대하여 책임을 지지 않습니다."),
                  _createElementVNode("p", null, "2. 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관해서는 책임을 지지 않습니다."),
                  _createElementVNode("p", null, "3. 회사는 서비스 이용과 관련하여 가입자에게 발생한 손해 중 가입자의 고의, 과실에 의한 손해에 대하여 책임을 지지 않습니다."),
                  _createElementVNode("h3", null, "제13조 (분쟁해결)"),
                  _createElementVNode("p", null, "1. 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다."),
                  _createElementVNode("p", null, "2. 회사와 이용자 간에 발생한 분쟁은 전자상거래 등에서의 소비자보호에 관한 법률에 따른 소비자분쟁조정위원회의 조정에 따를 수 있습니다."),
                  _createElementVNode("p", null, "3. 회사와 이용자 간에 발생한 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국거주자의 경우에는 민사소송법상의 관할법원에 제기합니다."),
                  _createElementVNode("h3", null, "부 칙"),
                  _createElementVNode("p", null, "이 약관은 2025년 1월 1일부터 적용됩니다.")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showTermsModal.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showPrivacyModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showPrivacyModal).value = $event)),
      "max-width": "800",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("개인정보처리방침", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"height":"500px"} }, {
              default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                _createElementVNode("div", { class: "privacy-content" }, [
                  _createElementVNode("h3", null, "1. 개인정보의 처리목적"),
                  _createElementVNode("p", null, "하이파이브 주식회사(이하 \"회사\")는 다음의 목적을 위하여 개인정보를 처리하고 있으며, 다음의 목적 이외의 용도로는 이용하지 않습니다."),
                  _createElementVNode("p", null, "- 회원 가입 및 관리"),
                  _createElementVNode("p", null, "- 재가장기요양센터 운영 관리 서비스 제공"),
                  _createElementVNode("p", null, "- 고객 상담 및 불만 처리"),
                  _createElementVNode("p", null, "- 서비스 개선 및 신규 서비스 개발"),
                  _createElementVNode("h3", null, "2. 개인정보의 처리 및 보유기간"),
                  _createElementVNode("p", null, "① 회사는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 또는 법령에 따른 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다."),
                  _createElementVNode("p", null, "② 구체적인 개인정보 처리 및 보유 기간은 다음과 같습니다."),
                  _createElementVNode("p", null, "- 회원 가입 및 관리: 회원 탈퇴 시까지"),
                  _createElementVNode("p", null, "- 서비스 제공: 서비스 이용계약 종료 시까지"),
                  _createElementVNode("p", null, "- 고객 상담: 상담 완료 후 3년"),
                  _createElementVNode("h3", null, "3. 개인정보의 제3자 제공"),
                  _createElementVNode("p", null, "① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다."),
                  _createElementVNode("p", null, "② 회사는 다음과 같은 경우에 개인정보를 제3자에게 제공하고 있습니다."),
                  _createElementVNode("p", null, "- 정보주체의 사전 동의를 받은 경우"),
                  _createElementVNode("p", null, "- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우"),
                  _createElementVNode("h3", null, "4. 개인정보처리 위탁"),
                  _createElementVNode("p", null, "① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다."),
                  _createElementVNode("p", null, "- 위탁업체: 클라우드 서비스 제공업체"),
                  _createElementVNode("p", null, "- 위탁업무: 시스템 운영 및 데이터 보관"),
                  _createElementVNode("p", null, "② 회사는 위탁계약 체결 시 개인정보보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다."),
                  _createElementVNode("h3", null, "5. 정보주체의 권리·의무 및 그 행사방법"),
                  _createElementVNode("p", null, "① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다."),
                  _createElementVNode("p", null, "1. 개인정보 처리현황 통지요구"),
                  _createElementVNode("p", null, "2. 개인정보 열람요구"),
                  _createElementVNode("p", null, "3. 개인정보 정정·삭제요구"),
                  _createElementVNode("p", null, "4. 개인정보 처리정지요구"),
                  _createElementVNode("p", null, "② 제1항에 따른 권리 행사는 회사에 대해 개인정보보호법 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다."),
                  _createElementVNode("h3", null, "6. 처리하는 개인정보의 항목"),
                  _createElementVNode("p", null, "회사는 다음의 개인정보 항목을 처리하고 있습니다."),
                  _createElementVNode("p", null, "- 필수항목: 아이디, 비밀번호, 장기요양기관기호"),
                  _createElementVNode("h3", null, "7. 개인정보의 파기"),
                  _createElementVNode("p", null, "① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다."),
                  _createElementVNode("p", null, "② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다."),
                  _createElementVNode("h3", null, "8. 개인정보의 안전성 확보조치"),
                  _createElementVNode("p", null, "회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다."),
                  _createElementVNode("p", null, "1. 개인정보 취급 직원의 최소화 및 교육"),
                  _createElementVNode("p", null, "2. 개인정보에 대한 접근 제한"),
                  _createElementVNode("p", null, "3. 개인정보를 안전하게 저장·전송할 수 있는 암호화 기법 사용"),
                  _createElementVNode("p", null, "4. 해킹 등에 대비한 기술적 대책"),
                  _createElementVNode("p", null, "5. 개인정보처리시스템 등의 접근권한 관리"),
                  _createElementVNode("h3", null, "9. 개인정보 보호책임자"),
                  _createElementVNode("p", null, "① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다."),
                  _createElementVNode("p", null, "▶ 개인정보 보호책임자"),
                  _createElementVNode("p", null, "성명: [담당자명]"),
                  _createElementVNode("p", null, "직책: [직책]"),
                  _createElementVNode("p", null, "연락처: [전화번호], [이메일], [팩스번호]"),
                  _createElementVNode("p", null, "② 정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다."),
                  _createElementVNode("h3", null, "10. 개인정보 처리방침 변경"),
                  _createElementVNode("p", null, "① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다."),
                  _createElementVNode("h3", null, "부 칙"),
                  _createElementVNode("p", null, "이 개인정보처리방침은 2025년 1월 1일부터 적용됩니다.")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (showPrivacyModal.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbar.value.show,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((snackbar.value.show) = $event)),
      color: snackbar.value.color,
      timeout: "2500",
      rounded: "lg",
      location: "top"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackbar.value.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}
}

})